<template>
  <div class="allContent">
    <div class="section">
      <van-sticky style="opacity: 0;">
        <van-nav-bar left-arrow safe-area-inset-top fixed v-if="state.navFlag">
          <template #left>
            <div class="left-nr" @click="goBack">
              <img src="../../../assets/nav/yz_nav_fh_w.png" alt="" />
            </div>
          </template>
        </van-nav-bar>
        <van-nav-bar left-arrow safe-area-inset-top fixed v-if="!state.navFlag">
          <template #left>
            <div class="left-nr" @click="goBack">
              <img src="../../../assets/nav/yz_nav_fh.png" alt="" />
            </div>
          </template>
          <template #title>
            <span style="color: #fff">社区</span>
          </template>
        </van-nav-bar>
      </van-sticky>
      <div class="top">
        <div class="gameInfo">
          <div>
            <img :src="state.communityInfo.pic1" alt="" />
            <div class="gameInfo_title">
              <span>{{ state.communityInfo.gamename }}</span>
              <p>{{ state.communityInfo.count }}帖子</p>
            </div>
          </div>
        </div>

        <div class="typecheckBox" ref="typeCheckBoxRef">
          <div>
            <ul>
              <li
                v-for="(item, index) in state.commentTypeList"
                :key="item.id"
                @click="changeType(item.id)"
                :class="{ active: item.id === state.currentTypeId }"
              >
                {{ item.name }}
              </li>
            </ul>
            <div class="content_title" @click="changeSort">
              <div v-if="state.sortFlag">
                <span>最新排序</span>
                <img
                  src="../../../assets/game/yz_game_comunity_hotsort.png"
                  alt=""
                />
              </div>
              <div v-else>
                <span>最热排序</span>
                <img
                  src="../../../assets/game/yz_game_comunity_hotsort.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 置顶区域 -->
        <div class="top_top" v-if="state.topComment.length > 0">
          <div class="top_coment">
            <ul>
              <li
                v-for="(item, index) in state.topComment"
                :key="index + '_topComment'"
                @click="goCommentDetails(item.id)"
              >
                <span>置顶</span>
                <p>{{ item.title }}</p>
                <img
                  src="../../../assets/gameCommunity/icon_gameCommunity_go.png"
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="content">
        <!-- 评论主体 -->
        <div class="content_center">
          <van-list
            v-model:loading="state.loading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <!-- <van-cell v-for="item in state.commentList" :key="item" :title="item" > -->
            <van-cell v-for="item in state.commentList" :key="item + 'comment'">
              <template #value>
                <!-- 评论详情组件 -->
                <commentItem
                  :data="item"
                  :like="state.isLike"
                  :deletePermission="state.deletePermission"
                  @likeThisComment="likeThisComment"
                  @goCommentDetails="goCommentDetails"
                  @deleteComment="deleteComment"
                >
                  >
                </commentItem>
              </template>
            </van-cell>
          </van-list>
        </div>
      </div>

      <div class="giveComment" @click="goCommentPublish">
        <img src="../../../assets/game/yz_game_conment.png" alt="" />
        <span>发表</span>
      </div>
      <div class="backToTop" v-if="state.backTopFlag" @click="backToTop">
        <img src="../../../assets/game/ya_game_backToTop.png" alt="" />
      </div>
    </div>
  </div>
  <van-overlay :show="state.overlayShow" duration="0">
    <van-loading color="#12CEC7"> 加载中... </van-loading>
  </van-overlay>
</template>
<script>
import { onBeforeRouteLeave, useRouter } from "vue-router";
import {
  ref,
  reactive,
  onMounted,
  onDeactivated,
  onActivated,
  nextTick,
} from "vue";
import { useStore } from "vuex";
import touxiang from "@/assets/touxiang_reset.png";
// 引入获取一级评论列表的接口
import {
  getCommentList,
  likeComment,
  getCommentType,
  getcommunityInfo,
  hideComment,
} from "@/api/yzCommunity.js";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
import { dateChangeFomat } from "@/utils/date.js";
import { deCodeEmoji } from "@/utils/emojiToCode";
import commentItem from "./components/commentItem.vue";
import { Local } from "@/utils/storage";
import { Dialog } from "vant";
import { setToken } from "@/utils/auth.js";

export default {
  name: "gameCommunity",
  components: {
    commentItem,
  },
  // 非评论详情页进入，刷新页面，返回顶部
  beforeRouteEnter(to, from, next) {
    // console.log('beforeRouteEnter-----------',from.name)
    if (from.name != "commentdetails") {
      next((vm) => {
        // console.log('beforeRouteEnter-----------',vm)
        (vm.state.loading = false),
          (vm.state.finished = false),
          (vm.state.activeNames = []),
          (vm.state.backTopFlag = false);
        (vm.state.commentList = []), (vm.state.isLike = []);
        (vm.state.page = 1), (vm.state.gid = getQueryString("gid"));
        vm.state.communityInfo = {};
        vm.state.allscrolldomNumber = 0;
        vm.state.currentTypeId = "";
        vm.state.overlayShow = true;
        vm.onLoad();
      });
    } else {
      next((vm) => {
        // 恢复滚动高度
        vm.state.scrollDom.scrollTop = vm.state.scrollHeight;
      });
    }
  },

  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      gid: "",
      uid: "",
      activeNames: [],
      allReview: "全部评论",
      reviewSort: "",

      // 评论列表加载状态
      finished: true,
      loading: true,
      // 评论数据
      commentList: [],
      // 滚动数据
      scrollDom: null,
      allscrollDom: null,
      allscrolldomNumber: "",
      navDom: null,
      backTopFlag: false,
      navFlag: true,
      typeFix: false,

      // 评论排序
      sortFlag: true,

      //已经点赞的评论
      isLike: [],
      page: 1,

      scrollHeight: 0,

      //顶部背景
      topDom: null,
      communityInfo: {},
      commentTypeList: [
        {
          id: "",
          name: "全部",
        },
      ],
      currentTypeId: "",
      deletePermission: false,
      topComment: [],

      overlayShow: true,
    });

    const typeCheckBoxRef = ref(null);

    onActivated(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
      }

      state.gid = getQueryString("gid");
      state.uid = getQueryString("uid");
      state.mobile = getQueryString("mobile");
      state.username = getQueryString("username");

      state.loading = false;
      state.finished = false;
      state.topComment = [];
      gettitleInfo();
      getType();

      nextTick(() => {
        state.topDom = document.getElementsByClassName("top")[0];
        state.scrollDom = document.getElementsByClassName("content_center")[0];

        state.allscrollDom = document.getElementsByClassName("allContent")[0];
        // console.log("获取滚动高度", state.navDom);

        state.typeCheckBox = typeCheckBoxRef.value;

        // 恢复原状态

        if (
          state.allscrolldomNumber &&
          state.allscrolldomNumber +
            document.getElementsByClassName("van-nav-bar")[0].offsetHeight >=
            state.topDom.offsetHeight
        ) {
          state.allscrollDom.scrollTop = state.allscrolldomNumber;
          state.navFlag = false;
        } else {
          state.navFlag = true;
          state.typeFix = false;
          state.typeCheckBox.style.position = "relative";
          state.typeCheckBox.style.top = "0";
          document.getElementsByClassName("content")[0].style.marginTop =
            0 + "px";
        }
      });
    });

    // 获取头部信息
    const gettitleInfo = async () => {
      let res = await getcommunityInfo({
        gid: state.gid,
        uid: state.uid,
      });
      state.overlayShow = false;
      if (res.data.a == "1") {
        state.communityInfo = res.data.c;
        state.topComment = res.data.c.topping;
        state.deletePermission = res.data.c.ids.includes(state.uid);
        // console.log("获取到的头部信息",state.communityInfo);
        nextTick(() => {
          state.topDom.style.backgroundImage = "url(" + res.data.c.pic3 + ")";
        });
      } else {
        console.log("获取失败", res);
      }
    };

    // 获取评论分类
    const getType = async () => {
      let res = await getCommentType({
        gid: state.gid,
        uid: state.uid,
      });
      if (res.data.a == "1") {
        state.commentTypeList.push(...res.data.c);
        // 除去数组对象中id重复的数据
        state.commentTypeList = state.commentTypeList.filter(
          (item, index, self) => {
            return self.findIndex((t) => t.id === item.id) === index;
          }
        );
        // console.log("获取到的评论分类", state.commentTypeList);
      } else {
        console.log("获取失败", res);
      }
    };

    // ----------------------获取评论-------------------------

    // 按照分类获取评论
    const changeType = (id) => {
      state.currentTypeId = id;
      state.page = 1;
      state.loading = true;
      state.finished = false;
      state.commentList = [];
      if (state.typeFix) {
        state.allscrollDom.scrollTop =
          state.topDom.offsetHeight - state.navDom.offsetHeight;
      }
      getComment();
    };

    var totalpage = 1;
    // var page=1;
    const onLoad = async () => {
      // console.log('加载更多')
      await getComment();
      //   state.finished = true;
    };
    // 获取评论
    const getComment = async () => {
      // console.log('这是第几页数据-------------',page)
      await getCommentList({
        gid: state.gid,
        uid: state.uid,
        pagecode: state.page,
        sort: state.sortFlag ? 0 : 1,
        ctype: state.currentTypeId,
      }).then((res) => {
        // console.log("获取到的评论列表", res.data.c);
        state.page = res.data.c.now_page;
        if (res.data.a == "1") {
          totalpage = res.data.c.total_page;
          if (state.page > totalpage) {
            state.finished = true;
          }
          if (res.data.c.lists.length == 0) {
            state.finished = true;
          } else {
            res.data.c.lists.forEach((item) => {
              if (item.createtime) {
                // 改写时间格式
                item.createtime = dateChangeFomat(item.createtime);
              }
            });
          }
          state.commentList = state.commentList.concat(res.data.c.lists);
          //遍历评论列表，获取已经点赞的评论
          state.commentList.forEach((item) => {
            if (item.isgood == "1" && state.isLike.indexOf(item.id) == -1) {
              state.isLike.push(item.id);
            }
            // 如果包含图片,把图片的src提取出来
            if (item.content.indexOf("<img") != -1) {
              // 使用正则将img标签中的src提取出来，放到数组中
              var imgReg = /<img.*?(?:>|\/>)/gi;
              var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
              var arr = item.content.match(imgReg);
              var srcArr = [];
              for (var i = 0; i < arr.length; i++) {
                var src = arr[i].match(srcReg);
                // 获取图片地址
                srcArr.push(src[1]);
              }
              // console.log('图片地址数组',srcArr)
              item.url = srcArr;
              // 将图片地址从content中删除
              item.content = item.content.replace(/<img.*?(?:>|\/>)/gi, "");
            }
            // 如果没头像就用默认头像
            if (!item.avatar) {
              item.avatar = touxiang;
            }
            // 将内容中的表情出来
            item.content = deCodeEmoji(item.content);
          });

          // console.log('评论点赞列表',state.isLike)

          var obj = {};
          state.commentList = state.commentList.reduce(function(item, next) {
            obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
            return item;
          }, []);

          // console.log('评论----',state.commentList)
          state.page++;
        }
      });
      state.loading = false;
    };

    // 跳转到评论详情
    const goCommentDetails = (item) => {
      // router.push({
      //   path: "/newgame/gameCommunity/commentdetails",
      //   query: {
      //     comments_id: item,
      //     gid: state.gid,
      //     username: state.username,
      //     uid: state.uid,
      //     mobile: state.mobile,
      //     deletePermission: state.deletePermission,
      //   },
      // });

      window.JsBridge.skipAppWebActivity(
        `${"game/gameCommunity/commentdetails?comments_id=" +
          item +
          "&gid=" +
          state.gid +
          "&uid=" +
          state.uid +
          "&username=" +
          state.username +
          "&mobile=" +
          state.mobile +
          "&deletePermission=" +
          state.deletePermission}˝`,
        "详情"
      );
    };
    // 改变评论排序
    const changeSort = () => {
      // console.log('改变排序')
      state.sortFlag = !state.sortFlag;
      state.page = 1;
      state.finished = false;
      state.loading = false;
      state.commentList = [];
      if (state.typeFix) {
        state.allscrollDom.scrollTop =
          state.topDom.offsetHeight - state.navDom.offsetHeight;
      }
      getComment();
    };
    // 改变点赞
    const likeThisComment = (id) => {
      // console.log('评论---------',state.commentList)
      likeComment({
        comments_id: id,
        uid: state.uid,
      }).then((res) => {
        if (res.data.a == "1") {
          state.commentList.forEach((item) => {
            if (item.id == id) {
              if (item.isgood == "1") {
                item.isgood = "0";
                item.good--;
                state.isLike.splice(state.isLike.indexOf(id), 1);
                Toast("取消点赞成功");
              } else {
                item.isgood = "1";
                item.good++;
                state.isLike.push(id);
                Toast("点赞成功");
              }
            }
          });
        }
      });
    };
    // 发表评论
    const goCommentPublish = () => {
      // router.push({
      //   path: "/newgame/gameCommunity/commentPublish",
      //   query: {
      //     gid: state.gid,
      //     gamename: state.communityInfo.gamename,
      //     username: state.username,
      //     uid: state.uid,
      //     mobile: state.mobile,
      //   },
      // });
      window.JsBridge.skipAppWebActivity(
        `${"game/gameCommunity/commentPublish?gid=" +
          state.gid +
          "&gamename=" +
          state.communityInfo.gamename +
          "&username=" +
          state.username +
          "&mobile=" +
          state.mobile +
          "&uid=" +
          state.uid}˝`,
        "发布"
      );
    };

    //隐藏帖子
    const deleteComment = (id) => {
      //   console.log("删除帖子", id);
      Dialog.confirm({
        title: "确认隐藏该帖子吗？",
        message: "隐藏之后如需展示，请去后台操作！",
      })
        .then(() => {
          // on confirm
          //   console.log("确认删除帖子，请求接口操作", id);
          hideComment({
            cid: id,
            uid: state.uid,
          }).then((res) => {
            if (res.data.a == "1") {
              Toast("隐藏帖子成功");
              state.finished = false;
              state.loading = false;
              state.commentList = [];
              state.page = 1;
              getComment();
            }
          });
        })
        .catch(() => {
          // on cancel
          Toast("取消隐藏帖子");
        });
    };

    // setTimeout(() => {
    //   state.allscrollDom.addEventListener("scroll", function() {
    //     if (state.allscrollDom.scrollTop > 100) {
    //       state.navFlag = false;
    //       state.navDom = document.getElementsByClassName("van-nav-bar")[0];
    //       state.navDom.style.background = "#090f1a";
    //     } else {
    //       state.navFlag = true;
    //     }

    //     if (state.navDom) {
    //       if (
    //         state.allscrollDom.scrollTop + state.navDom.offsetHeight >=
    //         state.topDom.offsetHeight
    //       ) {
    //         // 更改为固定定位
    //         state.typeFix = true;
    //         state.typeCheckBox.style.position = "fixed";
    //         state.typeCheckBox.style.top = state.navDom.offsetHeight - 2 + "px";
    //         document.getElementsByClassName("content")[0].style.marginTop =
    //           state.typeCheckBox.offsetHeight + "px";
    //       } else {
    //         state.typeFix = false;
    //         state.typeCheckBox.style.position = "relative";
    //         state.typeCheckBox.style.top = "0";
    //         document.getElementsByClassName("content")[0].style.marginTop =
    //           0 + "px";
    //       }
    //       //   console.log("滚动高度---------------", state.allscrollDom.scrollTop);
    //       state.allscrolldomNumber = state.allscrollDom.scrollTop;
    //     }

    //     // 回到顶部
    //     if (state.allscrollDom.scrollTop > 700) {
    //       state.backTopFlag = true;
    //     } else {
    //       state.backTopFlag = false;
    //     }
    //   });
    // }, 300);

    //返回顶部
    const backToTop = () => {
      state.allscrollDom.scrollTop = 0;
    };
    //路由离开时
    onBeforeRouteLeave((to, from, next) => {
      if (from.name == "community" && to.name == "gamedetails") {
        state.topDom.style.backgroundImage = "url()";
      }
      next();
    });

    const goBack = () => {
      window.document.location = "goBack://";
    };

    return {
      state,
      goCommentDetails,
      changeSort,
      likeThisComment,
      goCommentPublish,
      deleteComment,
      backToTop,
      onLoad,
      getType,
      changeType,
      typeCheckBoxRef,
      goBack,
    };
  },
};
</script>

<style scoped src="../../../styles/van-sticky-nav.css"></style>
<style scoped>
.van-nav-bar {
  background: rgba(0, 0, 0, 0);
  color: #333;
}
:deep(.van-sticky) {
  padding-top: 0;
}
:deep(.van-hairline--bottom::after) {
  border: 0;
}
:deep(.van-nav-bar__title span) {
  color: #333 !important;
}
/* :deep(.van-nav-bar__content) {
  margin-top: calc(50px + constant(safe-area-inset-top));
  margin-top: calc(50px + env(safe-area-inset-top));
} */
.van-cell {
  position: relative;
  display: flex;
  /* box-sizing: border-box; */
  width: 100%;
  padding: 0;
  /* overflow: hidden; */
  /* color: var(--van-cell-text-color); */
  font-size: var(--van-cell-font-size);
  line-height: var(--van-cell-line-height);
  background: none;
  margin-bottom: 30px;
  border-radius: 20px;
}
.allContent {
  height: 100vh;
  overflow: auto;
  /* overflow: hidden; */
  background-color: #f7f8fa;
  padding: 0px 0 80px;
  /* touch-action: none; */
}
.section {
  height: 100vh;
}

.typecheckBox {
  padding: 0 32px;
  margin-top: 12px;
  overflow: hidden;
  z-index: 99;
}
.typecheckBox > div {
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
  z-index: 99;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 0 16px 0;
}
.typecheckBox ul {
  display: flex;
  align-items: center;
  padding-left: 32px;
  overflow-x: auto;
  flex: 1;
}
.typecheckBox ul li {
  height: 42px;
  border-radius: 198px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #999;
  margin-right: 16px;
}
.typecheckBox ul .active {
  color: #12cec7;
}

.top {
  width: 100%;
  background-size: 100% 450px;
  background-repeat: no-repeat;
  position: relative;
}
.top .gameInfo {
  width: 100%;
  height: 450px;
  background: linear-gradient(180deg, rgba(27, 27, 27, 0.8) 0%, #020202 100%);
  padding-left: 32px;
  padding-top: 196px;
}
.top .gameInfo > div {
  height: 140px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  background: linear-gradient(90deg, #838383 0%, rgba(29, 29, 29, 0.25) 90%);
  border-radius: 20px 20px 20px 20px;
  border-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1),
      rgba(153, 153, 153, 0)
    )
    2 2;
}
.top .gameInfo img {
  width: 100px;
  height: 100px;
  border-radius: 20px;
}
.top .gameInfo .gameInfo_title {
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  margin-left: 20px;
}
.top .gameInfo .gameInfo_title p {
  margin-top: 8px;
  font-size: 24px;
}
.content {
  padding: 0 32px;
}
.content_title {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 32px;
  box-sizing: border-box;
  font-size: 24px;
  color: #666666;
}
.content_title img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.user_info .user_info_left img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 24px;
}
.user_info_left img:nth-of-type(2) {
  width: 56px;
  height: 22px;
  margin-left: 4px;
  border-radius: 0;
}
.user_info .user_info_right {
  /* width: 105px; */
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ff6666;
  padding: 4px 8px;
  border-radius: 6px;
  color: #fff;
}
.user_info .user_info_right span {
  font-size: 16px;
}
.user_comment {
  width: 552px;
  min-height: 86px;
  margin-left: 120px;
  font-size: 30px;
  color: #333333;
  margin-top: 8px;
}
.user_comment div {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
}
.user_comment div p {
  text-overflow: ellipsis;
}
.user_comment img {
  width: 268px;
  min-height: 200px;
}
.user_comment ul {
  display: flex;
  position: relative;
  padding-top: 32px;
}
.user_comment ul li {
  height: 100%;
}
.user_comment div:nth-of-type(2) img {
  margin-right: 16px;
  border-radius: 10px;
  height: 100%;
}
.user_bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  /* margin-left: 120px; */
  font-size: 24px;
  color: #999999;
}
.user_bottom .user_bottom_left {
  width: 80px;
  height: 32px;
  border-radius: 42px;
  background-color: #f0f1f5;
}
.user_bottom .user_bottom_right {
  display: flex;
  align-items: center;
  font-size: 30px;
}
.user_bottom .user_bottom_right div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_bottom .user_bottom_right img {
  width: 36px;
  height: 36px;
  margin-right: 4px;
  margin-bottom: 6px;
}
.user_bottom_right .review {
  display: flex;
  align-items: center;
  margin-right: 34px;
}

.giveComment {
  width: 100px;
  height: 100px;
  border-radius: 100px;
  position: fixed;
  right: 40px;
  bottom: 250px;
  background: #12cec7;
  border: 6px solid #10b2ad;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
}
.giveComment img {
  width: 40px;
  height: 40px;
}
.backToTop {
  position: fixed;
  right: 40px;
  bottom: 100px;
}
.backToTop img {
  width: 100px;
  height: 100px;
}
:deep(.van-cell:after) {
  position: relative;
}

.user_comment .moreImg {
  width: 268px;
  height: 100%;
  position: absolute;
  right: 0;
  /* top: 32px; */
  color: #fff;
  font-size: 50px;
  padding-bottom: 50px;
}
.user_comment .moreImg span {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 101%;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 置顶区域 */
.top_top {
  height: auto;
  width: 100%;
  margin: 12px 0 10px 0;
  padding: 0 32px;
}
.top_top .top_coment {
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.top_top .top_coment ul {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-content: space-around;
  padding: 18px 24px;
  padding-bottom: 0;
}
.top_top .top_coment li {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #333;
}
.top_top .top_coment li p {
  flex: 1;
}
.top_top .top_coment li img {
  width: 20px;
  height: 20px;
}
.top_top .top_coment li span {
  padding: 2px 12px;
  border: 2px solid #f66;
  border-radius: 6px;
  margin-right: 16px;
  color: #ff6666;
  font-size: 20px;
}

.van-overlay {
  background-color: #f7f8fa;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
